import { createGlobalStyle } from 'styled-components';
import styledSanitize from 'styled-sanitize';
import { fontFamilies } from './settings';
import { btnReset, getColor } from './tools';

const GlobalStyle = createGlobalStyle`
  ${styledSanitize}

  * { -webkit-tap-highlight-color: rgba(0,0,0,0); }

  html {
    text-size-adjust: 100%;
    text-rendering: optimizeSpeed;
    font-size: ${props => props.theme.baseFontSize}%;
  }

  body {
    font-family: ${fontFamilies.default};
    font-display: swap;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
    background: #fff;
  }

  button {
    ${btnReset}

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }

    &:active {
      color: inherit;
    }
  }
  
  a {
    color: inherit;
    text-decoration: none;
  }
  
  img {
    image-rendering: crisp-edges;
  }

  html,
  body,
  div,
  article,
  section,
  main,
  footer,
  header,
  form,
  fieldset,
  legend,
  pre,
  code,
  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  ol,
  li,
  dl,
  dt,
  dd,
  textarea,
  input[type='email'],
  input[type='number'],
  input[type='password'],
  input[type='tel'],
  input[type='text'],
  input[type='url'] {
    box-sizing: border-box;
  }

  figure {
    margin: 0;
  }

  main {
    width: 100%;
  }

  .lazyload,
  .lazyloading {
    opacity: 0;
    transition: opacity 400ms;
  }

  img.lazyloaded {
    transition: opacity 400ms;
    opacity: 1;
  }

  p {
    margin: 0;
  }
  
  i {
    font-style: italic;
  }

  b, strong {
    font-weight: 700;
  }

  @keyframes loadingBg {
    from {
      background: ${getColor('gray')};
    }

    to {
      background: ${getColor('lightGray')};
    }
  }


  @keyframes opacityLoading {
    from {
      opacity: 1;
    }

    to {
      opacity: 0.4;
    }
  }

  @media print {
    @page { margin: 2cm }

    *,
    *:before,
    *:after {
      background: transparent !important;
      color: #000 !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }

    a,
    a:visited {
      text-decoration: underline;
    }

    a[href]:after {
      content: ' (' attr(href) ')';
    }

    abbr[title]:after {
      content: ' (' attr(title) ')';
    }
    /*
    * Don't show links that are fragment identifiers
    */
    
    a[href^='#']:after,
    a[href^='javascript:']:after {
      content: '';
    }

    pre {
      white-space: pre-wrap !important;
    }

    pre,
    blockquote {
      border: 1px solid #999;
      page-break-inside: avoid;
    }

    /*
    * Printing Tables:
    * http://css-discuss.incutio.com/wiki/Printing_Tables
    */
    
    thead {
      display: table-header-group;
    }

    tr,
    img {
      page-break-inside: avoid;
    }

    p,
    h2,
    h3 {
      orphans: 3;
      widows: 3;
    }

    h2,
    h3 {
      page-break-after: avoid;
    }
  }

  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: ${props => props.theme.globalTheme.loading};
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
  }

  /* Page Transitions */
  #content {
    transform-origin: top;
  }

  .page-transition-enter #content{
    opacity: 0;
    transform: scale(0.95);
    
  }

  .page-transition-enter-active #content {
    transform: scale(1);
    opacity: 1;
    transition: all 400ms ease-in-out;
  }

  .page-transition-exit #content {
    opacity: 1;
    transform: scale(1);
  }

  .page-transition-exit-active #content {
    transform: scale(0.95);
    opacity: 0;
    transition: all 400ms ease-in-out;
  }

  body.floorPlan--is-open,
  body.navigation--is-open, 
  body.search--is-open,
  body.ReactModal__Body--open {
    position: relative;
    width: 100%;
    height: 100%;
    //padding-right: 15px;

    /* Detect touch devices and remove padding */
    @media (hover: none) and (pointer: coarse) {
      padding-right: 0;
    }
  }


  a.disabled {
    pointer-events: none !important;
    touch-events: none !important;
  }

  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip-path: inset(50%) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

`;

export default GlobalStyle;
